import { callBackendApi } from "../../../components/service/axios";

export const getUserGroupsListForUserView = async (selectedUserId) => {
  return await callBackendApi("get", `/bff/user-groups/user-view/${selectedUserId}`);
};
